declare let mxConstraintHandler;
declare let mxUtils;
declare let mxRectangle;
declare let mxEvent;

export function extendMxConstraintHandler() {
  this.resetHandler = mxUtils.bind(this, function (sender, evt) {
    if (this.currentFocus != null && this.graph.view.getState(this.currentFocus.cell) == null) {
      this.reset();
    } else {
      this.redraw();
    }
  });

  this.graph.view.addListener(mxEvent.SCALE, this.resetHandler);

  /**
   * Function: redraw
   *
   * Transfers the focus to the given state as a source or target terminal. If
   * the handler is not enabled then the outline is painted, but the constraints
   * are ignored.
   */
  mxConstraintHandler.prototype.redraw = function (evt) {
    if (this.currentFocus != null && this.constraints != null && this.focusIcons != null) {
      const state = this.graph.view.getState(this.currentFocus.cell);

      this.currentFocus = state;
      this.currentFocusArea = new mxRectangle(state.x, state.y, state.width, state.height);

      for (let i = 0; i < this.constraints.length; i++) {
        const cp = this.graph.getConnectionPoint(state, this.constraints[i]);
        const img = this.getImageForConstraint(state, this.constraints[i], cp);

        const bounds = new mxRectangle(
          Math.round(cp.x - img.width / 2),
          Math.round(cp.y - img.height / 2),
          img.width,
          img.height
        );

        this.focusIcons[i].bounds = bounds;
        this.focusIcons[i].redraw();
        this.currentFocusArea.add(this.focusIcons[i].bounds);
        this.focusPoints[i] = cp;
      }

      if (this.focusHighlight) {
        this.destroyFocusHighlight();
      }
    }
  };

  const destroy = mxConstraintHandler.prototype.destroy;

  mxConstraintHandler.prototype.destroy = function () {
    destroy.apply(this);

    this.graph.view.removeListener(mxEvent.SCALE, this.resetHandler);
  };
}
